module.exports = __webpack_public_path__ + "static/media/Dysrhythmia_Question1.de1eff84.jpg";